import { LocalizedAttributesValue } from 'src/generated/operations';

export function isFlowSensor<T extends LocalizedAttributesValue>(attribute?: T | null): boolean {
    return attribute?.raw?.includes('Flow') ?? false;
}
